//import React, {useEffect} from "react";
import React from "react";
import {carBrands} from "../../../AppConstants";
import {useHistory} from "react-router-dom";
import useMediaQuery from "@material-ui/core/useMediaQuery";
export default function (props) {
const history = useHistory();
  const isMobile = useMediaQuery('(max-width:769px)');

    return(
        <header style={{backgroundColor:'white'}} id={'header'} >
            <div className={"container"}>
             <div className={"row"}>
            <div style={{width:'200px',cursor:'pointer',display:'flex',flexDirection:'column',alignItems:'flex-start'}} className={"col-lg-12 logo"}>
                <img onClick={()=>{history.push('/')}} className={'vantrier'} alt="Van Trier" src="/assets/img/logo-white.png" style={{width:'200px'}}/>
                <p style={{fontSize:'15.7px',margin:'5px 0 0 0',width:'200px',color: '#2d2e2c80',fontFamily:'"Saira", sans-serif'}}>BRENGT JE IN BEWEGING</p>
              {props.brand &&  <img  style={{maxHeight:'100%',float:'right',width:`${isMobile && (props.brand.name.toLowerCase() === carBrands.mini.name) ? '200px':'unset'}`}} alt={`${props.brand.name} not found`}  src={props.brand.image}/>}
            </div>

        </div>
            </div>
        </header>
    )
}
